import React, { FC } from 'react';
import styled from '@emotion/styled';
import {
    HeaderContainer,
    SkipToContentLink,
    MainHeader,
    MobileMenuWrapper,
    MaxWidthContainer
} from './Header.styles';
import LogoMenu from './section/LogoMenu';
import PrimaryNav from './section/PrimaryNav';
import ProfileMenu from './section/ProfileMenu';
import { Props } from './Header.types';
import navData from './data/nav.json';
import { css } from '@emotion/react';
import BottomMenu from './section/BottomMenu';

import authentication from './scripts/authentication';
import headerUI from './scripts/ui';
import myhome from './scripts/myhome';

const HeaderWrapper = styled('div')(css`
    position: relative;
    z-index: 1000;
`);

const HeaderComponent: FC<Props> = (props) => {
    const encodedUrl = encodeURIComponent(props.path);
    const signInUrl = props.path.includes('/signin/')
        ? '/signin/'
        : `/signin/?page_after_login=${encodedUrl}&return_url=${encodedUrl}`;

    const authenticationScript = `(${authentication()})()`;
    const uiScript = `(${headerUI()})()`;
    const myhomeScript = `(${myhome()})()`;

    return (
        <HeaderWrapper>
            <HeaderContainer
                data-testid="header"
                data-tracking-experiment-variation={props.experimentVariation}
                data-is-logged-in="null"
            >
                <MainHeader data-universal-header>
                    <SkipToContentLink href="#main-content">
                        Skip to main content
                    </SkipToContentLink>
                    <MaxWidthContainer data-universal-header-container>
                        <LogoMenu signInUrl={signInUrl} />
                        <MobileMenuWrapper data-testid="header-mobile-menu">
                            <ProfileMenu signInUrl={signInUrl} />
                            <PrimaryNav navItems={navData.navbar.items} />
                            <BottomMenu signInUrl={signInUrl} />
                        </MobileMenuWrapper>
                    </MaxWidthContainer>
                </MainHeader>
            </HeaderContainer>
            <script
                dangerouslySetInnerHTML={{
                    __html: uiScript
                }}
            />
            <script
                dangerouslySetInnerHTML={{
                    __html: authenticationScript
                }}
            />
            <script
                dangerouslySetInnerHTML={{
                    __html: myhomeScript
                }}
            />
        </HeaderWrapper>
    );
};

const Header = styled(HeaderComponent)();
export { Header };
